import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
  shapes,
} from '@backstage/theme';

// Reusable page theme config
const defaultPageThemeConfig = {
  colors: ['#228189'],
  shape: shapes.none,
  backgroundImage: 'linear-gradient(180deg, #228189 0%)', // 'linear-gradient(rgb(249 249 249) 0%)',
  fontColor: '#ffffff', // '#228189',
};

export const customTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#1B3647',
      },
      secondary: {
        main: '#1b3647',
      },
      error: {
        main: '#B02828',
      },
      warning: {
        main: '#8f5e15',
      },
      info: {
        main: '#34548a',
      },
      success: {
        main: '#485e30',
      },
      background: {
        default: '#f7f8fa',
        paper: '#ffffff',
      },
      banner: {
        info: '#34548a',
        error: '#1b3647',
        text: '#1b3647',
        link: '#565a6e',
      },
      errorBackground: '#1b3647',
      warningBackground: '#8f5e15',
      infoBackground: '#1b3647',
      navigation: {
        background: '#1b3647',
        indicator: '#ffffff',
        color: '#d5d6db',
        selectedColor: '#ffffff',
      },
    },
  }),
  typography: {
    htmlFontSize: 16,
    fontFamily: 'roboto, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: 76,
      fontWeight: 500,
      marginBottom: 10,
    },
    h2: {
      fontSize: 45,
      fontWeight: 500,
      marginBottom: 8,
    },
    h3: {
      fontSize: 34,
      fontWeight: 500,
      marginBottom: 6,
    },
    h4: {
      fontWeight: 500,
      fontSize: 24,
      marginBottom: 6,
    },
    h5: {
      fontWeight: 500,
      fontSize: 24,
      marginBottom: 4,
    },
    h6: {
      fontWeight: 500,
      fontSize: 20,
      marginBottom: 2,
    },
  },
  defaultPageTheme: 'home',
  fontFamily: 'roboto, Helvetica, Arial, sans-serif',
  /* below drives the header colors */
  pageTheme: {
    home: defaultPageThemeConfig,
    documentation: defaultPageThemeConfig,
    tool: defaultPageThemeConfig,
    service: defaultPageThemeConfig,
    website: defaultPageThemeConfig,
    library: defaultPageThemeConfig,
    other: defaultPageThemeConfig,
    app: defaultPageThemeConfig,
    apis: defaultPageThemeConfig,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Roboto, Helvetica',
          fontSize: '14px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontFamily: 'Roboto',
          fontWeight: '400',
          fontSize: '16px',
          lineHeight: '16px',
          color: 'rgb(8, 22, 32)',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottom: '1px solid #1B3647', // Default underline color
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottom: '2px solid #1B3647', // Hover color
          },
          '&:after': {
            borderBottom: '2px solid #228189', // Focused color
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // textTransform: 'none', // optional: removes uppercase styling
          borderRadius: '4px', // optional: change button shape
        },
        containedPrimary: {
          fontFamily: 'Roboto',
          fontSize: '14px',
          fontWeight: 500,
          backgroundColor: '#228189',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#228189',
          },
        },
        outlinedPrimary: {
          borderColor: '#228189',
          color: '#228189',
          '&:hover': {
            backgroundColor: '#f0f0f0',
          },
        },
      },
    },
  },
});
